import React, { useId } from 'react'

// types
import { CustomRadioButtonProps } from './types'

// styles
import * as SC from './CustomRadioButtonsStyles'

const CustomRadioButtons = <V extends string = string>(props: CustomRadioButtonProps<V>) => {
	const { options, value, onChange, name, label, labelVisuallyHidden = false, disabled, loading, size = 'default' } = props
	const labelId = useId()

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>, v: V, optionDisabled?: boolean) => {
		e.stopPropagation()
		if (optionDisabled || loading) {
			return
		}
		if (e.target.checked) {
			onChange(v)
		}
	}

	return (
		<SC.Wrapper>
			{label && (
				<SC.Label id={labelId} $visuallyHidden={labelVisuallyHidden}>
					{label}
				</SC.Label>
			)}
			<SC.RadioButtonsWrapper role={'radiogroup'} aria-labelledby={label ? labelId : undefined}>
				{options.map((option) => {
					const checked = option.id === value
					const optionDisabled = disabled || option.disabled
					return (
						<SC.RadioButtonLabel key={option.id} htmlFor={option.id} $disabled={optionDisabled || loading}>
							<SC.RadioButton
								type={'radio'}
								name={name}
								id={option.id}
								checked={checked}
								disabled={optionDisabled}
								aria-disabled={loading && !optionDisabled ? true : undefined}
								onChange={(e) => handleChange(e, option.id, optionDisabled)}
							/>
							<SC.CustomLabel $size={size}>
								<SC.LabelTitle $size={size}>{option.label}</SC.LabelTitle>
								<SC.LabelDescription>{option.description}</SC.LabelDescription>
							</SC.CustomLabel>
						</SC.RadioButtonLabel>
					)
				})}
			</SC.RadioButtonsWrapper>
		</SC.Wrapper>
	)
}

export default CustomRadioButtons
